<template>
    <div>
        <sorts
                class="content-sorting"
                :inputs="updatedSorts"
                @sorting="sortContent"
                :extendButton="false"
                :sorts="defaultSelected"
                :columns="12"
                :forceUpdate="true"
        >
        </sorts>
    </div>
</template>

<script>
    import sorts from '@/components/global/sorting';
    import {isEmpty, get, filter} from 'lodash';
    import { Event } from 'vue-tables-2';

    export default {
        props: {
            tableLoading: {
                type: Boolean,
                default: false
            },
            sorts: {
                type: Array,
                default: () => ([])
            }
        },
        name: 'ContentConversionSorting',
        components: {
            sorts,
        },
        data() {
            return {
                selectOptions: {
                    order: []
                },
                loader: false,
                currentOrder: '',
                defaultSelected: {},
            }
        },

        computed: {
            updatedSorts() {
                if( !isEmpty(this.sorts) ) {
                    this.sorts.forEach( (sort) => {
                        sort.options = get(this.selectOptions, sort.response_object);
                    });
                }
                return this.sorts;
            },
        },
        mounted() {
            this.getSelectOptions('content/analytics/filters');
            this.sorts.forEach( (sort) => {
                if( !isEmpty(sort.defaultValue) ) {
                    this.defaultSelected[sort.name] = sort.defaultValue;
                    this.currentOrder = sort.defaultValue.value;
                }
            });
        },
        methods: {
            getSelectOptions(url) {
                this.loader = true;
                try {
                    this.loader = true;
                    this.getData(url, {}).then(({data}) => {
                        if (data) {
                            this.selectOptions.order = this.mapSelectOptions(data.order);
                            this.$forceUpdate();
                        }
                    })
                } catch (e) {
                    console.log(e)
                } finally {
                    this.loader = false;
                }
            },

            mapSelectOptions(options) {
                if( isEmpty(options) ) {
                    return [];
                }

                return filter(options, (item) => !!item.title).map(option => {
                    if (option.title && option.id) {
                        return {
                            label: option.title,
                            value: option.id
                        }
                    } else if (option.title) {
                        return {
                            label: option.title,
                            value: option.title
                        }
                    }
                });
            },

            sortContent(params) {
                Event.$emit('vue-tables.contentConversionTable.filter::sorting', params);
            },
        },
        destroyed() {
        },
    };
</script>
<style lang="scss" scoped>
    .content-sorting {
        position: relative;
        background-color: white;
        padding-left: 12px;
    }
</style>